/**
 * @generated SignedSource<<5eacc99c08b91837621298cec1b885d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainContacts_order$data = {
  readonly email: string | null;
  readonly phone: string | null;
  readonly scoroContactId: string | null;
  readonly scoroOrderId: number | null;
  readonly " $fragmentType": "OrderEditMainContacts_order";
};
export type OrderEditMainContacts_order$key = {
  readonly " $data"?: OrderEditMainContacts_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainContacts_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainContacts_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scoroContactId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scoroOrderId",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "236fd7ad03e8638cc12c9353a634967d";

export default node;
